import { RootState } from '@cp/src/store';
import { InfoIcon } from '@navi/web-ui/lib/icons';
import ClockFilledIcon from '@navi/web-ui/lib/icons/ClockIcon';
import { Typography } from '@navi/web-ui/lib/primitives';
import { useSelector } from 'react-redux';
import { getStepLabel } from '../consts';

const InProgressFooter = () => {
  const summaryData = useSelector((state: RootState) => state.allocations?.summaryData);
  const stepCount = summaryData?.executionData?.length;

  return (
    <div className="w-full bg-[var(--navi-color-orange-bg)] h-9 flex items-center justify-between">
      <div className="flex items-center gap-2 mx-6">
        <Typography variant="h4" color="var(--navi-color-gray-c2)">
          Status :
        </Typography>
        <ClockFilledIcon color="var(--navi-color-orange-dark)" />
        <Typography variant="h4" color="var(--navi-color-orange-dark)">
          In Progress : {getStepLabel(summaryData?.executionData?.[stepCount - 1]?.stepName)}
        </Typography>
      </div>
      <div className="flex items-center gap-1 mx-6 ">
        <InfoIcon fill={'var(--navi-color-orange-dark)'} />
        <Typography color="var(--navi-color-orange-dark)" variant="h4">
          Might take up to 30 min
        </Typography>
      </div>
    </div>
  );
};

export default InProgressFooter;
